// extracted by mini-css-extract-plugin
export var active = "PaginatedContent-module--active--14fd3";
export var heading = "PaginatedContent-module--heading--0e6f5";
export var pagination = "PaginatedContent-module--pagination--e0240";